import { Button, MenuItem, Stack, TextField, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import { BrandPayload } from 'src/app/api/openapi';
import { BrandClient } from 'src/app/api/clients/brands';

const CreateBrand = () => {
  const navigate = useNavigate();
  const { orgId } = useParams();

  const handleCreateBrand = (values: BrandPayload) => {
    if (!orgId) return alert("Can't update product. Missing organization ID.");
    BrandClient.createBrand(orgId, values).then(({ data }) =>
      navigate('/brands')
    );
  };

  return (
    <Formik
      initialValues={{
        id: null,
        name: '',
        default_language: 'en_US',
        parent: null,
      }}
      onSubmit={handleCreateBrand}
    >
      {({ submitForm, getFieldProps }) => (
        <>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="h1">Create Brand</Typography>
            <Button variant="flat" onClick={submitForm}>
              Create
            </Button>
          </Stack>
          <Stack component="form" alignItems="center" width="100%">
            <Stack direction="row" width="100%">
              <TextField
                label="Brand Name"
                {...getFieldProps('name')}
                sx={{ m: 1, width: '100%' }}
              />
            </Stack>
            <Stack direction="row" width="100%">
              <TextField
                label="Default Language"
                select
                {...getFieldProps('default_language')}
                sx={{ m: 1, width: '100%' }}
              >
                <MenuItem value="en_US">English {`(US)`}</MenuItem>
                <MenuItem value="en_GB">English {`(UK)`}</MenuItem>
              </TextField>
            </Stack>
          </Stack>
        </>
      )}
    </Formik>
  );
};

export default CreateBrand;
